<script>
import vDialog from "@/components/_Shared/Dialog";
import SuccessDialog from "@/components/Freshdesk/Success/Success";
import Modal from "@/components/_Shared/Modal";
import vDatePicker from "@/components/_Shared/DatePicker/DatePicker";
import HourPicker from "@/components/_Shared/HourPicker";
import dateHelper from "@/utils/helpers/date";
import eventHelper from "@/utils/helpers/event";
import moment from "moment";

import freshdeskMixin from "@/mixins/freshdeskMixin";
import { mapActions } from "vuex";

export default {
  mixins: [freshdeskMixin],
  props: {
    order: Object
  },
  components: {
    vDialog,
    vDatePicker,
    HourPicker,
    SuccessDialog,
    Modal
  },
  updated() {
    if (this.day) {
      this.requiredData = false;
    }
  },
  data() {
    return {
      day: null,
      requiredData: false,
      loader: false,
      disableSendTicketButton: false,
      startsAt: eventHelper.initialBusinessHour(),
      endsAt: eventHelper.finalBusinessHour(),
      keepProfessional: false,
      successDialogVisibility: false,
      reschedule: false
    };
  },
  methods: {
    ...mapActions("freshdesk", ["createRescheduleTicket", "setAbsence"]),
    changeStarts(val) {
      this.startsAt = val;
    },
    getData() {
      let date = moment(this.order.schedule_event.starts_at);
      this.day = date < moment() ? null : date.toDate();
      this.startsAt = date.hour();
    },
    setTicketTags(order) {
      this.setCustomerTypeTag(order);
      this.setAdvanceTimeTag(order);
      this.isAbsenceTicket();
    },
    async submit() {
      if (this.day == null) {
        this.requiredData = true;
        return;
      }
      if (this.disableSendTicketButton) return;
      this.disableSendTicketButton = true;
      this.loader = true;
      this.setTicketTags(this.order);
      this.setAbsence(true);
      try {
        let payload = {
          order: this.order,
          newData: this.$data,
          tags: this.ticketTags
        };
        await this.createRescheduleTicket(payload);
        this.successDialogVisibility = true;
        this.loader = false;
      } catch (e) {
        this.disableSendTicketButton = false;
        this.loader = false;
        this.$toasted.error(e);
      }
    },
    closeSuccessDialog() {
      this.successDialogVisibility = false;
    },
    closeRescheduleDialog() {
      this.$emit("back");
    },
    setMaxTimePicker() {
      let orderDuration = this.order.schedule_event.duration / 60;
      this.endsAt = eventHelper.getValidInitialHourByDuration(orderDuration);
    }
  },
  computed: {
    keepProfessionalText() {
      return this.keepProfessional
        ? "Prefiro tentar reagendar com o mesmo profissional autônomo que agendei"
        : "Não tenho preferência por profissional autônomo específico";
    },
    beforeStarts() {
      return dateHelper.getStartsAt(this.order.schedule_event.starts_at);
    },
    afterStarts() {
      return `${dateHelper.getDate(this.day)}, ${dateHelper.getNameDay(
        this.day
      )}, às ${this.startsAt}h`;
    },
    maxRange() {
      return this.startsAt == this.endsAt
        ? "<p>O horário máximo para início dessa <br>limpeza é às <b>" +
            this.endsAt +
            "h:00</b></p>"
        : "";
    }
  },
  mounted() {
    this.getData();
    this.setMaxTimePicker();
  }
};
</script>

<template>
  <div 
    @click="$emit('close')"
  >
    <modal
      title="COMUNICAR FALTA DE PROFISSIONAL"
      size="lg"
    >
      <template slot="body">
        <form @submit.prevent="submit">
          <p>Prefiro reagendar a limpeza com outra profissional em:</p>
          <div class="pickers"> 
            <div>
            <h3>Nova data para a limpeza:</h3>
            <v-date-picker v-model="day"/>
            <div v-if="requiredData">
              <p class="requiredWarning">Por favor seleciona uma data</p>
            </div>
            </div>
            <div>
            <h3>Novo horário de início da limpeza:</h3>
            <hour-picker :max="endsAt" :value="startsAt" @changed="changeStarts" /> 
					    <div class="requiredWarning" v-html="maxRange"></div>
            </div>
          </div>
            
          <div>

          <div class="radio-group">
            <input id="any" type="radio" name="keep" :value="false" v-model="keepProfessional" />
            <label for="any">
              <p>Não tenho preferência por profissional autônomo específico</p>
            </label>
          </div>
          </div>


          <h3 class="mt-30">Resumo da solicitação de reagendamento:</h3>
            <div class="reschedule-info">
              Agendado para o dia:
              <span>{{beforeStarts}}</span>
            </div>
            <div v-if="day" class="reschedule-info">
              Desejo agendar para o dia:
              <span>{{afterStarts}}</span>
            </div>
          <div class="keep-professional-text">{{keepProfessionalText}}</div>

          <base-flex>
            <button class="btn bg-purple-outline"
             @click="$emit('back')"
             type="button">
              voltar
            </button>
            <button class="btn bg-purple-outline"
             @click="$emit('close')"
             type="button">
              cancelar
            </button>
            <button 
              class="btn bg-purple" 
              type="submit" 
              :class="{'btn--loading': loader}" 
              :disabled="disableSendTicketButton"
              @click="submit()"> 
              {{ !loader ? "solicitar reagendamento" : "" }}
            </button>
          </base-flex>
        </form>
      </template>
    </modal>
    <success-dialog 
      :visible="successDialogVisibility"
      @close="closeSuccessDialog(); closeRescheduleDialog()"
    />
  </div>
</template>

<style lang="scss" scoped>
p {
  font-weight: 500;
  color: $purple;
  text-align: center;
}

.btn {
  text-transform: uppercase;
}
.reschedule-info {
  font-size: 14px;
  margin-bottom: 10px;
  span {
    font-weight: 500;
  }
}
.observation {
  color: $pink;
  text-align: center;
  font-size: 14px;
  a {
    color: $pink;
    text-decoration: underline;
  }
}
.pickers {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
}
.keep-professional-text {
  margin-top: 10px;
  margin-bottom: 26px;
  font-size: 14px;
  font-weight: bold;
  color: #484848;
  @media (min-width: 768px) {
    text-align: left;
  }
}
form {
  display: flex;
  flex-direction: column;
  text-align: center;
  @media (min-width: 768px) {
    text-align: unset;
  }
}
h3 {
  font-size: 16px;
  font-weight: 300;
  margin-bottom: 10px;
  color: #484848;
}
.radio-group {
  label {
    opacity: 0.6;
    border-radius: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: $purple;
    text-align: center;
    cursor: pointer;
    flex-direction: row;
    p {
      margin-left: 10px;
    }
    &::before {
      content: "";
      display: inline-block;
      min-width: 10px;
      min-height: 10px;
      border-radius: 100%;
      border: 2px solid $purple;
      margin-bottom: 5px;
    }
    @media (max-width: 768px) {
      text-align: left;
    }
  }
  input {
    display: none;
    &:checked ~ label {
      opacity: 1;
      &::before {
        background-color: $purple;
      }
    }
  }
}

.requiredWarning {
  font-size: 14px;
  color: $pink;
  text-align: center;
}

.professionalText {
  font-size: 16px;
  color: $purple;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Freshdesk/Absence/Reschedule/Reschedule.vue